function f(r) {
  var n = Array.prototype.slice.call(window.document.querySelectorAll("script"));
  return n.find(function(e) {
    return e.src === r;
  });
}
function m(r, n) {
  var e = f(r);
  if (e !== void 0) {
    var d = e?.getAttribute("status");
    if (d === "loaded")
      return Promise.resolve(e);
    if (d === "loading")
      return new Promise(function(i, u) {
        e.addEventListener("load", function() {
          return i(e);
        }), e.addEventListener("error", function(o) {
          return u(o);
        });
      });
  }
  return new Promise(function(i, u) {
    var o, t = window.document.createElement("script");
    t.type = "text/javascript", t.src = r, t.async = !0, t.setAttribute("status", "loading");
    for (var a = 0, l = Object.entries({}); a < l.length; a++) {
      var s = l[a], v = s[0], p = s[1];
      t.setAttribute(v, p);
    }
    t.onload = function() {
      t.onerror = t.onload = null, t.setAttribute("status", "loaded"), i(t);
    }, t.onerror = function() {
      t.onerror = t.onload = null, t.setAttribute("status", "error"), u(new Error("Failed to load ".concat(r)));
    };
    var c = window.document.getElementsByTagName("script")[0];
    (o = c.parentElement) === null || o === void 0 || o.insertBefore(t, c);
  });
}
function w(r) {
  var n = f(r);
  return n !== void 0 && n.remove(), Promise.resolve();
}
export {
  m as loadScript,
  w as unloadScript
};
//# sourceMappingURL=index56.js.map
